// extracted by mini-css-extract-plugin
export var circle = "_az-1";
export var exitConfirmationModal = "_az-5";
export var iframe = "_az-0";
export var offline = "_az-3";
export var online = "_az-2";
export var workstationSelectError = "_az-4";